import { useNavigate } from "react-router-dom";
import { Instagram, LogIn } from "lucide-react";
import { FaTiktok, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { User } from "@supabase/supabase-js";

interface FooterProps {
  user: User | null;
}

const Footer = ({ user }: FooterProps) => {
  const navigate = useNavigate();

  return (
    <footer className="bg-card border-t border-border/50 mt-16">
      <div className="max-w-6xl mx-auto px-6 py-10">
        {/* Top: Logo + Social */}
        <div className="flex flex-col items-center gap-6 mb-8 md:flex-row md:justify-between">
          <h2 className="text-2xl font-bold text-foreground">Tecly</h2>
          <div className="flex items-center gap-1.5">
            {!user && (
              <>
                <button
                  onClick={() => navigate("/auth")}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-muted hover:bg-muted/80 transition-all text-xs font-medium text-foreground"
                >
                  <LogIn className="w-3.5 h-3.5" />
                  Accedi
                </button>
                <button
                  onClick={() => navigate("/auth?tab=register")}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary hover:bg-primary/90 transition-all text-xs font-medium text-primary-foreground"
                >
                  Registrati
                </button>
                <div className="w-px h-4 bg-border mx-1" />
              </>
            )}
            <a href="https://www.instagram.com/tecly.it?igsh=MXR1bmQ0bGdtbjBsNw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-muted transition-all group">
              <Instagram className="w-5 h-5 text-muted-foreground group-hover:text-foreground transition-colors" />
            </a>
            <a href="https://www.tiktok.com/@tecly6?_r=1&_t=ZN-92lek6T8jry" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-muted transition-all group">
              <FaTiktok className="w-5 h-5 text-muted-foreground group-hover:text-foreground transition-colors" />
            </a>
            <a href="https://whatsapp.com/channel/0029VbCTNmGICVft1h5A2z2u" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-muted transition-all group">
              <FaWhatsapp className="w-5 h-5 text-muted-foreground group-hover:text-foreground transition-colors" />
            </a>
            <a href="https://t.me/Teclynet" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full hover:bg-muted transition-all group">
              <FaTelegramPlane className="w-5 h-5 text-muted-foreground group-hover:text-foreground transition-colors" />
            </a>
          </div>
        </div>

        {/* Links */}
        <div className="grid grid-cols-2 gap-6 mb-8 md:grid-cols-4">
          <div>
            <h3 className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Navigazione</h3>
            <ul className="space-y-2">
              <li><button onClick={() => navigate("/prodotti")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Prodotti</button></li>
              <li><button onClick={() => navigate("/news")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">News</button></li>
              <li><button onClick={() => navigate("/sfondi")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Sfondi</button></li>
              <li><button onClick={() => navigate("/confronta-iphone")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Confronta iPhone</button></li>
              <li><button onClick={() => navigate("/apple-store")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Apple Store</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">App</h3>
            <ul className="space-y-2">
              <li><button onClick={() => navigate("/install")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Scarica per iOS</button></li>
              <li><button onClick={() => navigate("/install")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Scarica per Android</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Legale</h3>
            <ul className="space-y-2">
              <li><button onClick={() => navigate("/privacy")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</button></li>
              <li><button onClick={() => navigate("/cookie")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Cookie Policy</button></li>
              <li><button onClick={() => navigate("/termini")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Termini di Servizio</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Supporto</h3>
            <ul className="space-y-2">
              <li><a href="mailto:info@tecly.it" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contattaci</a></li>
              
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border/50 pt-6 flex flex-col items-center gap-2 md:flex-row md:justify-between">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Tecly. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-muted-foreground">
            Made with ❤️ in Italy
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
